module.exports = __webpack_public_path__ + "img/indigent6_7-8-2021.e78349f8.jpg";